import { Component, Prop, h } from '@stencil/core';

import { onFireDREvent } from '../../../actions/actions.offer';

@Component({
  tag: 'offer-ineligible',
  styleUrl: 'offer-ineligible.css',
})
export class OfferIneligible {
  @Prop() offerId: string = '';
  @Prop() consumerEmail: string = '';
  @Prop() consumerZip: string = '';
  @Prop() vehicleName: string = '';
  @Prop() whenReviewVehicleDetailsClicked: (evt: MouseEvent) => void = () => {};
  @Prop() useTradeIn: boolean = false;
  @Prop() useTradeInButtonText: string = '';
  @Prop() showKelleyBuysYourCar: boolean = false;

  render() {
    return (
      <div class="mb-14">
        <h1 class="text-2xl mb-6">
          {!this.showKelleyBuysYourCar ? (
            <span>Your vehicle isn't eligible for a Kelley Blue Book&reg; Instant Cash Offer, but we can still help.</span>
          ) : (
            <span>Your vehicle isn't eligible for a Kelley Buys Your Car Offer.</span>
          )}
        </h1>
        <div class="text-center md:text-left">
          <div class="mb-6">
            <div class="font-bold">{this.vehicleName}</div>
            <a href="#" class="no-underline" onClick={(e) => this.whenReviewVehicleDetailsClicked(e)}>
              Review vehicle details
            </a>
          </div>

          <div class="text-xs mb-8">
            <div>Offer ID: {this.offerId}</div>
            {this.consumerEmail && <div>Email: {this.consumerEmail}</div>}
            <div>ZIP Code: {this.consumerZip}</div>
          </div>

          {!this.showKelleyBuysYourCar && (
            <div class="mb-8">
              Questions about the Instant Cash Offer program?{' '}
              <span class="font-bold">
                Call&nbsp;
                <ico-hyperlink href="tel:(866) 559-5268" noUnderline>
                  (866) 559-5268
                </ico-hyperlink>
              </span>
            </div>
          )}

          {!this.showKelleyBuysYourCar && this.useTradeIn && (
            <div class="flex xs:justify-center md:justify-start mb-8">
              <ico-button buttonStyle="final-action" label={this.useTradeInButtonText} whenClicked={onFireDREvent.bind(this, this.useTradeInButtonText)} />
            </div>
          )}
        </div>
      </div>
    );
  }
}
